import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import './Blog.css';

function BlogPage() {
    const iframeRef = useRef(null);
    const [iframeHeight, setIframeHeight] = useState('800px');
    const location = useLocation();

    // Pobierz parametr url z query string
    const params = new URLSearchParams(location.search);
    const blogUrl = params.get('url') ? `https://blog.squareplan.io/${params.get('url').replace(/^\//, '')}` : 'https://blog.squareplan.io';
    const reloadKey = location.search;

    useEffect(() => {
        function handleMessage(event) {
            console.log('Received message from iframe0000000:', event);
            if (event.data && event.data.type === 'BLOG_INFO') {
                setIframeHeight(event.data.height + 'px');
            }

            if (event.data && event.data.path) {
                const newUrl = `/blog?url=${encodeURIComponent(event.data.path.replace(/^\//, ''))}`;
                if (window.location.pathname + window.location.search !== newUrl) {
                    window.history.replaceState({}, '', newUrl);
                }
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }
        }
        window.addEventListener('message', handleMessage);
        return () => window.removeEventListener('message', handleMessage);
    }, []);

    return (
        <div className="blog-iframe-wrapper">
            <iframe
                key={reloadKey}
                ref={iframeRef}
                src={blogUrl}
                title="SquarePlan Blog"
                frameBorder="0"
                scrolling="no"
                allowFullScreen
                className="blog-iframe"
                style={{ height: iframeHeight }}
            />
        </div>
    );
}

export default BlogPage;
